import pmMobileHeroImage from "/public/images/landing/hero/pm_mobile.png";
import pmDesktopHeroImage from "/public/images/landing/hero/pm_desktop.png";
import mktMobileHeroImage from "/public/images/landing/hero/mkt_mobile.png";
import mktDesktopHeroImage from "/public/images/landing/hero/mkt_desktop.png";

export const pmHeroImage = {
  mobile: pmMobileHeroImage,
  desktop: pmDesktopHeroImage,
};

export const PMTitleData = () => {
  return {
    title: (
      <>
        실무 기반 프로젝트로
        <br />
        전문성 있는 PM이 되세요
      </>
    ),
    subtitle: <>직장 병행 IT 부트캠프</>,
  };
};

export const pmCTAText = "PM 코스 지원하기";

export const pmSummaryData = [
  { title: "교육 기간", content: "7/22(토)\n~ 10/21(토)" },
  { title: "교육 방법", content: "100%\n온라인" },
  { title: "지원 마감", content: "7/14(금)\n23:59까지" },
];

export const mktHeroImage = {
  mobile: mktMobileHeroImage,
  desktop: mktDesktopHeroImage,
};

export const MktTitleData = () => {
  return {
    title: (
      <>
        데이터로 소통하는
        <br />
        마케터가 되세요
      </>
    ),
    subtitle: <>그로스 마케팅 부트캠프</>,
  };
};

export const mktCTAText = "마케터 코스 지원하기";

export const mktSummaryData = [
  { title: "교육 기간", content: "6/10(토) \n~ 9/2(토)" },
  { title: "교육 방법", content: "100%\n온라인" },
  { title: "지원 마감", content: "5/15(월)\n23:59까지" },
];
